import { SPLIT_NAMES } from '@/constants';
import { useUserStore } from '@/piniaStores/user/user.store';

export function getDelighted(): Window['delighted'] {
  return window.delighted;
}

export function loadDelightedSurvey() {
  const userStore = useUserStore();

  if (
    !userStore.getIsSplitEnabled(SPLIT_NAMES.SSR_IFRAME) ||
    import.meta.env.VITE_DELIGHTED_ENABLED !== 'true' ||
    !userStore.user ||
    !userStore.userActiveCompany
  ) {
    return;
  }

  const delighted = getDelighted();

  if (!delighted) {
    return;
  }

  delighted.survey({
    initialDelay: 2592000,
    recurringPeriod: 15552000,
    name: userStore.user.firstName + ' ' + userStore.user.lastName,
    email: userStore.user.email,
    createdAt: userStore.user.dateJoined,
    properties: {
      company_id: userStore.userActiveCompany.id,
      username: userStore.user.username,
      user_id: userStore.user.id,
      user_joined: userStore.user.dateJoinedVerbose,
      last_login: userStore.user.lastLogin,
      belongs_to_buyer_company: userStore.userActiveCompany.buyer,
      belongs_to_seller_company: userStore.userActiveCompany.seller,
      medical: userStore.userActiveCompany.licenses.some((license) => {
        if (typeof license.type === 'string') {
          return license.type.toLowerCase() === 'medical';
        }

        return license.type.typeCode === 'MED';
      }),
      recreational: userStore.userActiveCompany.licenses.some((license) => {
        if (typeof license.type === 'string') {
          return ['recreational', 'adult use'].includes(license.type.toLowerCase());
        }

        return ['MED', 'ADU'].includes(license.type.typeCode);
      }),
      api: userStore.user.hasApiAccess,
      s2s: userStore.user.hasS2SEnabled,
      states: userStore.user.statesAbbr,
    },
  });
}
